import $ from './el.JsModules.js';

elabs.NewsletterService = class {
  'use strict';

  async signupNewsletter(emailAddress, source = 'website', additionalProperties = {}) {
    if (!this.isValidEmail(emailAddress)) {
      throw new Error('Please enter a valid email address');
    }

    const subscriptionData = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: emailAddress,
                ...additionalProperties,
              },
            },
          },
          custom_source: source,
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: 'TBxENm',
            },
          },
        },
      },
    };

    try {
      const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=XLNef5', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2025-04-15',
        },
        body: JSON.stringify(subscriptionData),
      });

      if (response.ok) {
        console.log('Successfully subscribed to Klaviyo list');
        return { success: true, message: 'Successfully subscribed to newsletter!' };
      } else {
        const errorData = await response.json();
        console.error('Subscription failed:', errorData);
        throw new Error('Subscription failed. Please try again.');
      }
    } catch (error) {
      console.error('Newsletter Subscription error:', error);
      throw new Error('Subscription failed. Please try again.');
    }
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  handleSuccess() {
    localStorage.setItem('el-customer-has-subscribed-to-newsletter', 'true');
    console.log('Newsletter subscription successful');
  }

  showError(message = 'An error occurred. Please try again.') {
    console.error('Newsletter signup error:', message);
    alert(message);
  }
};

// Create a singleton instance
elabs.onJavascriptReady(function () {
  elabs.newsletterService = new elabs.NewsletterService();
}); 